import clsx from "clsx";
import { useLocale } from "hooks";
import { Fragment, useState, type FC } from "react";
import type { Swiper as ISwiper } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import translation from "../translation";
import { slugMaker } from "utils/normalizer";

interface IProps {
  onTabChange: Function;
  tabCategory: string;
  sortedMenus: Array<any>;
  faculty: any;
}

const Tabs: FC<IProps> = ({
  onTabChange,
  tabCategory,
  sortedMenus,
  faculty,
}) => {
  const { isRTL, locale } = useLocale();
  const [swiperInstance, setSwiperInstance] = useState<ISwiper | null>(null);

  const handlePreviousSlideClick = () => {
    swiperInstance?.slidePrev();
  };

  const handleNextSlideClick = () => {
    swiperInstance?.slideNext();
  };

  return (
    <div className="tw-text-sm tw-relative">
      <div
        className={clsx(
          "tw-absolute tw-top-0 tw-h-full tw-flex md:tw-hidden tw-z-50 tw-bg-[#F6F7FB]",
          {
            "tw-right-0": isRTL,
            "tw-left-0": !isRTL,
          }
        )}
      >
        <button
          type="button"
          onClick={handlePreviousSlideClick}
          className={clsx(
            "tw-w-full tw-cursor-pointer tw-text-[#344456] tw-text-base xxxl:tw-text-[21.33px] tw-font-bold tw-px-3 tw-ml-4 tw-py-2.5 tw-bg-zero tw-border-0 tw-min-w-fit"
          )}
        >
          <svg
            style={{ rotate: `${isRTL ? 0 : 180}deg` }}
            width="7"
            height="11"
            viewBox="0 0 7 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.158333 9.61667L3.975 5.79167L0.158333 1.96667L1.33333 0.791667L6.33333 5.79167L1.33333 10.7917"
              fill="#212B36"
            />
          </svg>
        </button>
      </div>
      <div
        className={clsx(
          "tw-absolute tw-top-0 tw-h-full tw-flex md:tw-hidden tw-z-50 tw-bg-[#F6F7FB]",
          {
            "tw-right-0": !isRTL,
            "tw-left-0": isRTL,
          }
        )}
      >
        <button
          type="button"
          onClick={handleNextSlideClick}
          className={clsx(
            "tw-w-full tw-cursor-pointer tw-text-[#344456] tw-text-base xxxl:tw-text-[21.33px] tw-font-bold tw-px-3 tw-ml-4 tw-py-2.5 tw-bg-zero tw-border-0 tw-min-w-fit"
          )}
        >
          <svg
            style={{ rotate: `${isRTL ? 0 : 180}deg` }}
            width="7"
            height="11"
            viewBox="0 0 7 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.84167 9.40833L3.025 5.58333L6.84167 1.75833L5.66667 0.583333L0.666667 5.58333L5.66667 10.5833"
              fill="#212B36"
            />
          </svg>
        </button>
      </div>
      <div className="tw-w-4/5 md:tw-w-full tw-mx-auto md:tw-mx-0">
        <Swiper
          key={locale}
          onSwiper={setSwiperInstance}
          spaceBetween={0}
          centeredSlides={false}
          slidesPerView="auto"
          className="slider tw-overflow-visible tw-mx-auto md:tw-mx-[unset]"
          dir={isRTL ? "rtl" : "ltr"}
        >
          {sortedMenus?.map?.((item, i, theArr) => {
            if (item?.name === "IUMS") {
              return (
                <Fragment key={i}>
                  <SwiperSlide className="md:tw-flex-1 tw-h-full tw-w-fit">
                    <div
                      className={clsx(
                        "tw-group tw-relative tw-bg-zero tw-border-0 tw-flex tw-justify-center tw-items-center tw-cursor-pointer tw-group tw-border-solid tw-border-b-4 tw-border-zero tw-border-x-0 0 tw-border-t-0 tw-py-2.5 tw-h-full tw-w-full tw-text-center",
                        {
                          "!tw-border-[#007FAC] tw-text-[#007FAC]":
                            tabCategory?.includes?.(
                              translation[locale]?.MAPPED_IUMS_TABS.COURSES.slug
                            ) ||
                            tabCategory?.includes?.(
                              translation[locale]?.MAPPED_IUMS_TABS.TIME_TABLE
                                .slug
                            ),
                          "tw-pl-4": isRTL,
                          "tw-pr-4": !isRTL,
                        }
                      )}
                    >
                      <span className="tw-text-sm xxxl:tw-text-base tw-px-4 group-hover:tw-text-[#007FAC]">
                        {translation[locale]?.MAPPED_IUMS_TABS.COURSES.name}{" "}
                        {translation[locale]?.AND}{" "}
                        {translation[locale]?.MAPPED_IUMS_TABS.TIME_TABLE.name}
                      </span>
                      <svg
                        className={clsx(
                          "tw-min-w-[2px] tw-min-h-5 tw-absolute",
                          {
                            "tw-mr-2 tw-left-0": isRTL,
                            "tw-ml-2 tw-right-0": !isRTL,
                          }
                        )}
                        width="2"
                        height="20"
                        viewBox="0 0 2 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.125"
                          width="1.5"
                          height="20"
                          fill="#9FA6B1"
                          fillOpacity="0.47"
                        />
                      </svg>
                      <svg
                        width="11"
                        height="7"
                        viewBox="0 0 11 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.675 0.150024L5.5 3.97502L9.325 0.150024L10.5 1.33336L5.5 6.33336L0.5 1.33336L1.675 0.150024Z"
                          fill="#344456"
                        />
                      </svg>
                      <div className="tw-absolute tw-right-0 tw-top-[84px] tw-z-10 tw-hidden group-hover:tw-block tw-bg-[#F6F7FB] tw-w-[140px] tw-rounded-b-lg tw-border tw-border-[#0000001a] xxxl:tw-text-[14px]">
                        <button
                          className="tw-bg-zero tw-border-0 tw-block tw-py-2.5 tw-cursor-pointer tw-w-full tw-text-right tw-px-5 hover:tw-text-[#007FAC] tw-border-b tw-border-[#F6F7FB]/20"
                          type="button"
                          onClick={() =>
                            onTabChange({
                              name: translation[locale]?.MAPPED_IUMS_TABS
                                .COURSES.name,
                              slug:
                                translation[locale]?.MAPPED_IUMS_TABS.COURSES
                                  .slug +
                                "-" +
                                slugMaker(faculty?.title),
                              id: 1,
                              entityId: 1,
                            })
                          }
                        >
                          {translation[locale]?.MAPPED_IUMS_TABS.COURSES.name}
                        </button>
                        <button
                          className="tw-bg-zero tw-border-0 tw-block tw-py-2.5 tw-cursor-pointer tw-w-full tw-text-right tw-px-5 hover:tw-text-[#007FAC]"
                          type="button"
                          onClick={() =>
                            onTabChange({
                              name: translation[locale]?.MAPPED_IUMS_TABS
                                .TIME_TABLE.name,
                              slug:
                                translation[locale]?.MAPPED_IUMS_TABS.TIME_TABLE
                                  .slug +
                                "-" +
                                slugMaker(faculty?.title),
                              id: 2,
                              entityId: 2,
                            })
                          }
                        >
                          {
                            translation[locale]?.MAPPED_IUMS_TABS.TIME_TABLE
                              .name
                          }
                        </button>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="md:tw-flex-1 tw-h-full tw-w-fit">
                    <button
                      className={clsx(
                        "tw-bg-zero tw-border-0 tw-flex tw-justify-center tw-items-center tw-cursor-pointer tw-py-2.5 tw-border-solid tw-border-b-4 tw-border-zero tw-border-x-0 0 tw-border-t-0 tw-h-full tw-w-full",
                        {
                          "!tw-border-[#007FAC] tw-text-[#007FAC]":
                            tabCategory?.includes(
                              translation[locale]?.MAPPED_IUMS_TABS.THESIS.slug
                            ),
                          "hover:tw-text-[#007FAC]": !tabCategory?.includes(
                            translation[locale]?.MAPPED_IUMS_TABS.THESIS.slug
                          ),
                        }
                      )}
                      type="button"
                      onClick={() =>
                        onTabChange({
                          name: translation[locale]?.MAPPED_IUMS_TABS.THESIS
                            .slug,
                          slug:
                            translation[locale]?.MAPPED_IUMS_TABS.THESIS.slug +
                            "-" +
                            slugMaker(faculty?.title),
                          id: 3,
                          entityId: 3,
                        })
                      }
                    >
                      <span
                        className={clsx(
                          "!tw-text-sm xxxl:!tw-text-base tw-flex tw-items-center tw-px-4"
                        )}
                      >
                        {translation[locale]?.MAPPED_IUMS_TABS.THESIS.name}
                        <svg
                          className={clsx(
                            "tw-min-w-[2px] tw-min-h-5 tw-absolute",
                            {
                              "tw-mr-2 tw-left-0": isRTL,
                              "tw-ml-2 tw-right-0": !isRTL,
                            }
                          )}
                          width="2"
                          height="20"
                          viewBox="0 0 2 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.125"
                            width="1.5"
                            height="20"
                            fill="#9FA6B1"
                            fillOpacity="0.47"
                          />
                        </svg>
                      </span>
                    </button>
                  </SwiperSlide>
                </Fragment>
              );
            }
            return (
              <SwiperSlide
                key={i}
                className="md:tw-flex-1 tw-h-full tw-w-fit"
                id={`tab-${item?.id}`}
              >
                <a
                  onClick={() => onTabChange(item)}
                  className={clsx(
                    "tw-bg-zero tw-border-0 tw-flex tw-justify-center tw-items-center tw-cursor-pointer tw-py-2.5 tw-border-zero tw-border-solid tw-border-b-4 tw-border-x-0 0 tw-border-t-0 tw-w-full tw-h-full tw-text-center",
                    {
                      "!tw-border-[#007FAC] tw-text-[#007FAC]":
                        tabCategory === item?.slug,
                      "hover:tw-text-[#007FAC]": tabCategory !== item?.slug,
                    }
                  )}
                >
                  <span
                    className={clsx(
                      "!tw-text-sm xxxl:!tw-text-base tw-border tw-px-4",
                      {
                        "tw-border-l": isRTL,
                        "tw-border-r": !isRTL,
                      }
                    )}
                  >
                    {item?.name?.split?.("-")?.[0]}
                  </span>
                  {theArr.length !== i + 1 && (
                    <svg
                      className={clsx("tw-min-w-[2px] tw-min-h-5 tw-absolute", {
                        "tw-left-0": isRTL,
                        "tw-right-0": !isRTL,
                      })}
                      width="2"
                      height="20"
                      viewBox="0 0 2 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.125"
                        width="1.5"
                        height="20"
                        fill="#9FA6B1"
                        fillOpacity="0.47"
                      />
                    </svg>
                  )}
                </a>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default Tabs;
